export const Form = {
  numrCertidao: "",
  statCertidao: "",
  valrEmolumento: "",
  valrBruto: "",
  valrIr: "",
  valrHonorario: "",
  valrLiquido: "",
  dataEmissao: "",
  dataEntrega: "",
  dataValidade: "",
  dataQuitacao: "",
  dataAutenticacao: "",
  dataValidacaoBeneficiario: "",
  dataSituacao: "",
  dataCancelamento: "",
  pessoa: {
    nomePessoa: "",
    numrCpf: "",
    servidor: {
      numrMatricula: "",
    },
  },
  obrigacao: {
    orgao: {
      descOrgao: "",
    },
    tipoCertidao: {
      codgTipoCertidao: "",
      nomeTipoCertidao: "",
    },
  },
};

const url = "/certidoes";
const id = "idenCertidao";
const urlRelatorios = "/relatorios";

export function pesquisar(filtro) {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}?${filtro}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function pesquisarAll() {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/all`).then((res) => {
      resolve(res.data);
    });
  });
}

export function buscarPorCodigo(codigo) {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/${codigo}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function pesquisarAmparo(filtro) {
  return new Promise((resolve, reject) => {
    window.$http.post(`/amparoslegais/ativos/filtro`, JSON.stringify(filtro)).then((res) => {
      resolve(res.data);
    });
  });
}

export function salvar(parm) {
  return new Promise(async (resolve, reject) => {
    if (parm[id] && parm[id] !== 0) {
      await atualizar(parm).then((res) => {
        resolve({ ...res, type: "UPD" });
      });
    } else {
      await criar(parm).then((res) => {
        resolve({ ...res, type: "INS" });
      });
    }
  });
}

export function remover(data) {
  return new Promise((resolve, reject) => {
    window.$http.delete(`${url}/${data[id]}`).then((res) => {
      resolve();
    });
  });
}

export function atualizar(parm) {
  return new Promise((resolve, reject) => {
    window.$http.put(`${url}/${parm[id]}`, JSON.stringify(parm)).then((res) => {
      resolve(res.data);
    });
  });
}

export function criar(parm) {
  return new Promise((resolve, reject) => {
    window.$http.post(`${url}`, JSON.stringify(parm)).then((res) => {
      resolve(res.data);
    });
  });
}

export const exportarValidaCertidao = (payload) => {
  return new Promise(async (resolve, _) => {
    const response = await window.$http.post(`${urlRelatorios}/gerarexcelvcl`, JSON.stringify(payload));
    resolve(response.data);
  });
};

export const imprimirValidaCertidao = (payload) => {
  return new Promise(async (resolve, _) => {
    const response = await window.$http.post(`${urlRelatorios}/gerarpdfvcl`, JSON.stringify(payload));
    resolve(response.data);
  });
};

export function orgaoService() {
  return new Promise((resolve, reject) => {
    window.$http.get(`/orgaos/naoextintos/semOrgaosVinculados`).then((res) => {
      resolve(res.data);
    });
  });
}
export function tipoAtoService() {
  return new Promise((resolve, reject) => {
    window.$http.get(`/tipoatos/all`).then((res) => {
      resolve(res.data);
    });
  });
}

export function buscarCertidaoAtivaLegada(idenCertidao) {
  if (idenCertidao === 0) {
    return null;
  }

  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/buscarCertidaoAtivaLegada/${idenCertidao}`).then((res) => {
      resolve(res.data);
    });
  });
}



